import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import OrderCard from "./OrderCard.jsx"; // Adjusted for correct naming
import { useDispatch, useSelector } from "react-redux";
import { getAllOrdersOfUser } from "../../redux/action/order.js";
import burgerImage from "../../assets/burgerimage.png";
import { Link } from "react-router-dom";
import { addToCart } from "../../redux/action/cart.js";
import { useNavigate } from "react-router-dom";
import { TfiReload } from "react-icons/tfi";
import Swal from "sweetalert2";
import Cookies from 'js-cookie'
import { showCustomAlert } from "../User/Signup/Toast.jsx";
function PastOrdersSection() {
  const itemsPerRow = 4; // 4 items per row
  const rowsPerPage = 2; // 2 rows per page
  const navigate = useNavigate()
  const itemsPerPage = itemsPerRow * rowsPerPage; // Total items per page = 8
 const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const { orders } = useSelector((state) => state.order); // Fetch orders from Redux store
  console.log(orders);
  
  const { user } = useSelector((state) => state.user); // Get the logged-in user
   const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
   const statusRes =  Cookies.get(`restaurantStatus_${RestaurantSavedId}`)
  const [page, setPage] = useState(1); // Start on page 1
  const totalPages = orders?.totalPages || 1; // Total pages from the orders object

  useEffect(() => {
    if (user?._id) {
      dispatch(getAllOrdersOfUser(user._id, page, undefined, undefined, RestaurantSavedId)); // Dispatch action to fetch orders based on the page number
    }
  }, [page, user?._id, dispatch, RestaurantSavedId]);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage); // Update the page state
    }
  };
  const addToCartHandler = (product, quantity = 1, discountValue = 0) => {
    // Ensure the comparison matches the structure of your product and cart
    const isItemExists = cart.find((item) => item.productId === product.productId);  

    console.log("isItemExists", isItemExists); // Debugging output

    const discountAmount = (product.price * discountValue) / 100;
    const finalPrice = (product.price - (discountAmount || 0)).toFixed(2);

    if (isItemExists) {
        const updatedProduct = {
            ...isItemExists,
            quantity: isItemExists.quantity + quantity, // Add the correct quantity
        };
        dispatch(addToCart(updatedProduct));
    } else {
        // Add the product if it doesn't exist
        dispatch(addToCart({ ...product, quantity, price: finalPrice }));
    }
};



const handleReorder = (order) => {
  if (statusRes === 'closed') {
    showCustomAlert({
      title: 'Restaurant is closed!',
      html: '<p style="color: #555;">Restaurant is not accepting orders right now</p>',
      icon: 'success',
      confirmButtonText: 'ok',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: 4000
    });
  } else {
    order.items.forEach((item) => {
      addToCartHandler(item, item.quantity); // Pass correct quantity
    });

    Swal.fire({
      title: 'Order Readded!',
      html: '<p style="color: #555;">Your previous order has been added to the cart. Proceed to checkout to complete your purchase.</p>',
      icon: 'success',
      confirmButtonText: 'Checkout',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: null
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/my-cart');
      }
    });
  }
};


  return (
    <div className="self-center mt-8 w-full max-w-[95%] max-md:max-w-full">
      <h1 className="heading text-[34.92px] text-[#AF313D]  mb-6 flex items-center max-sm:pl-4 sm:pl-3">
        Your Previous Orders
      </h1>

      {orders?.results?.length > 0 ? (
        <>
          {/* Card Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-4 gap-5 mb-4">
            {orders.results.map((order) =>(
              <div key={order._id} className="flex flex-col">
                 <div className="flex flex-col px-4 py-4 mx-auto rounded-3xl shadow-lg bg-[#F8F8F8] border border-gray-200 w-full max-w-[300px]">
                      <img src={order?.items[0]?.image} alt={"imae"} className="w-full rounded-xl aspect-[1.35]" />
                      <div className="mt-4 flex justify-between items-center">
                      {order?.items?.map((name, index) => (
  <h2 key={index} className="text-base font-bold body flex flex-wrap text-zinc-800 truncate ">
    {name.name}{index !== order.items.length - 1 ? ', ' : ''}
  </h2>
))}


                        <p className="text-base font-bold body text-[#AF313D] ">{order?.totalPrice}&pound;</p>
                      </div>
                      <div className="flex justify-between items-center mt-4">
                        <button className="text-xs text-[#AF313D]  body shadow px-3 py-1 rounded-md bg-white cursor-default">
                        {new Date(order.createdAt).toLocaleDateString()}
                        </button>
                        <div  onClick={()=> handleReorder(order)} className="bg-[#AF313D] w-8 h-8 flex justify-center items-center rounded-full">
                          <TfiReload color="white" className="text-base" />
                        </div>
                        </div>
                      {/* <p className="mt-2 text-sm text-gray-600 body line-clamp-2">{description}</p> */}
                      {/* <div className="flex justify-between items-center mt-4">
                        <button className="text-xs text-[#AF313D]  body shadow px-3 py-1 rounded-md bg-white cursor-default">
                          {date}
                        </button>
                        <div onClick={onClick} className="bg-[#AF313D] w-8 h-8 flex justify-center items-center rounded-full">
                          <TfiReload color="white" className="text-base" />
                        </div>
                      </div> */}
                    </div>
              {/* <OrderCard
                name={order.items[0]?.name} 
                price={`£${item.basePrice}`} // Display base price
                date={new Date(order.createdAt).toLocaleDateString()} // Use order's creation date
                description={item.description} // Display item description
                imageSrc={item?.image || burgerImage} // Use item's image or placeholder
                onClick={()=> handleReorder(order)}
              /> */}
            </div>
            )
           
            )}
          </div>

          {/* Pagination Controls */}
          <div className="flex justify-between items-center mt-4">
            <button
              className="p-2 hover:bg-gray-300 rounded-l-lg"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              <FaArrowLeft />
            </button>

            <span>{page} of {totalPages}</span>

            <button
              className="p-2 hover:bg-gray-300 rounded-r-lg"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === totalPages}
            >
              <FaArrowRight />
            </button>
          </div>
        </>
      ) : (
       <>
<div className="flex flex-col items-center justify-center mt-8 space-y-4">
  <p className="text-center text-gray-500">
    You haven't placed any orders.
  </p>
 <Link to="/menu">
 <button
    className="bg-[#AF313D] text-white w-[139px] h-[45.57px] px-4 py-2 rounded-full text-sm mb-5 font-medium hover:bg-red-700"
  >
    Order Now
  </button>
 </Link>
</div>



     </>
      )}
    </div>
  );
}

export default PastOrdersSection;
